import engageBase from './engageBase';
import branchBase from './branchBase';

export default ({ classes }) => [
  ...engageBase({ classes }),
  {
    labelText: 'Product & Services Showcase',
    name: 'showcase',
    children: branchBase({ classes })
  }
];
